import { useState, useEffect } from 'react';
import { updateLeads} from '../../../api'; // adjust the import as needed
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Swal from 'sweetalert2';

interface LeadEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedRow: any;
  onUpdate: () => void;
}



interface LeadData {
  lead_id: number;
  name: string;
  email: string;
  phone: string;
  type: string;
  status: string;
  comment:string;
  created_by: string;
}
const statusOptions = ["fresh-lead", "In Progress", "Reviewed", "Converted", "Rejected"];

const LeadEditModal = ({ isOpen, onClose, selectedRow, onUpdate }: LeadEditModalProps) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [formData, setFormData] = useState<LeadData>({
    lead_id: 0,
    name: "",
    email: "",
    phone: "",
    type:"",
    status: "",
    comment: "",
    created_by: "",
  });

  useEffect(() => {
    console.log("Received selectedRow in modal:", selectedRow);
    if (selectedRow) {
      setFormData({
        lead_id: selectedRow.id || "", // Ensure it's a string
        name: selectedRow.Name || "",
        email: selectedRow.Email || "",
        phone: selectedRow.Phone || "",
        type: selectedRow.Type || "",
        status: selectedRow.Status || "",
        comment: selectedRow.Comment || "",
        created_by: selectedRow.CreatedBy || "",
      });
    }
  }, [selectedRow]);

  const validateForm = () => {
    let errors: { [key: string]: string } = {};
    
    // Name Validation (Only letters, no numbers)
    if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      errors.name = "Name must contain only letters.";
    }

    // Email Validation
    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      errors.email = "Invalid email format.";
    }

    // Phone Validation
    // if (formData.phone) {
    //   try {
    //     const phoneNumber = parsePhoneNumberFromString(formData.phone);
    //     if (!phoneNumber || !isValidPhoneNumber(formData.phone)) {
    //       errors.phone = "Invalid phone number.";
    //     }
    //   } catch (error) {
    //     errors.phone = "Invalid phone number.";
    //   }
    // }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePhoneChange = (value: string | undefined) => {
    setFormData((prev) => ({
      ...prev,
      phone: value || "",
    }));
  };
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const handleUpdate = async () => {
    if (!validateForm()) return;
    if (!formData.lead_id) {
      console.error("Error: lead_id is missing", formData);
      return;
    }

    try {
      await updateLeads(formData);
      onUpdate(); // Refresh table data
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Lead details have been updated successfully.",
        timer: 2000,
        showConfirmButton: false,
      });

      // Clear form after updating
      // setFormData({
      //   lead_id: 0,
      //   name: "",
      //   email: "",
      //   phone: "",
      //   type: "",
      //   status: "",
      //   comment: "",
      //   created_by: "",
      // });

      onClose(); // Close modal
    } catch (error) {
      console.error("Error updating lead:", error);
    }
  };

  return (
    <div className={`modal fade ${isOpen ? "show" : ""}`} tabIndex={-1} style={{ display: isOpen ? "block" : "none" }}>
      <div className="modal-dialog">
        <div className="modal-content" style={{ marginTop: "10rem" }}>
          <div className="modal-header">
            <h3 className="modal-title">Edit Lead</h3>
            <button className="btn btn-icon btn-sm btn-active-secondary ms-2" onClick={onClose}>
              <i className="ki-solid ki-cross fs-2x"></i>
            </button>
          </div>
          <div className="modal-body" style={{ height: "40vh", overflow: "auto" }}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" />
              {errors.name && <div className="text-danger">{errors.name}</div>}
            </div>
            
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" />
              {errors.email && <div className="text-danger">{errors.email}</div>}
            </div>
            
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">Phone</label>
              <PhoneInput
                country={'us'}
                value={formData.phone}
                onChange={handlePhoneChange}
                inputClass='form-control'
                inputStyle={{
                  width: '100%', 
                  height: '42px',
                  borderRadius: '4px', 
                  border: '1px solid #ced4da',
                }}
              />
              {errors.phone && <div className="text-danger">{errors.phone}</div>}
            </div>

            <div className="mb-3">
              <label htmlFor="status" className="form-label">Status</label>
              <select name="status" value={formData.status} onChange={handleSelectChange} className="form-control">
                {statusOptions.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="type" className="form-label">Type</label>
              <input type="text" name="type" value={formData.type} onChange={handleChange} className="form-control" />
            </div>

            <div className="mb-3">
              <label htmlFor="comment" className="form-label">Comment</label>
              <input type="text" name="comment" value={formData.comment} onChange={handleChange} className="form-control" />
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onClose}>Close</button>
            <button type="button" className="btn" style={{ backgroundColor: "#6D9300", color: "white" }} onClick={handleUpdate}>Save changes</button>
          </div>
        </div>
      </div>
    </div>
  );
};

  

export default LeadEditModal;

  